import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ModelVariantThresholdsList from './ModelVariantThresholdsList';
import { getModelVariantThresholds, getFlowSequenceForModel, getComponentPositionsForModel, getUserProfileWidget, getUserOrgModelCategoryType, getModelManager } from '../../selectors/index';
import {
  getThresholdsThunk,
  describeThresholdThunk,
  postThresholdThunk,
  setThresholdChangeThunk,
  setThresholdShowScreenStatusThunk,
  setCurrentPage,
  setPageFilter,
} from '../../actions/modelVariantThreshold';
import { describeModelThunk } from '../../actions/model';

const mapStateToProps = state => {
  return {
    modelManager: getModelManager(state),
    thresholds: getModelVariantThresholds(state),
    flowSequences: getFlowSequenceForModel(state),
    userProfileWidgets: getUserProfileWidget(state),
    modelComponentPositions: getComponentPositionsForModel(state),
    userModelCategories: getUserOrgModelCategoryType(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { 
      describeModel: (modelId, modelCategoryId) =>
        describeModelThunk(modelId, null, 'MODEL_CONFIGURE', modelCategoryId, true, true),
      getModelVariantThresholds: (offset, limit, filter, modelId, modelVariantId, modelCategoryId) =>
        getThresholdsThunk(offset, limit, filter, modelId, modelVariantId, modelCategoryId, 'MODELVARIANTTHRESHOLDS'),
      saveModelThreshold: (modelVariantThreshold, widgetCode) => postThresholdThunk(modelVariantThreshold, widgetCode),
      describeModelThreshold: (modelThresholdId, modelVariantId, modelCategoryId) =>
        describeThresholdThunk(modelThresholdId, modelVariantId, modelCategoryId, 'MODELVARIANTTHRESHOLDSEDIT'),
      changeModelThreshold: selectedModel => setThresholdChangeThunk(selectedModel),
      setThresholdShowScreenStatus: status => setThresholdShowScreenStatusThunk(status),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelVariantThresholdsList);
